/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserRewardLedgerEntryReferredUserDetails } from './UserRewardLedgerEntryReferredUserDetails';
import {
    UserRewardLedgerEntryReferredUserDetailsFromJSON,
    UserRewardLedgerEntryReferredUserDetailsFromJSONTyped,
    UserRewardLedgerEntryReferredUserDetailsToJSON,
    UserRewardLedgerEntryReferredUserDetailsToJSONTyped,
} from './UserRewardLedgerEntryReferredUserDetails';
import type { UserRewardLedgerEntryVehicleDetails } from './UserRewardLedgerEntryVehicleDetails';
import {
    UserRewardLedgerEntryVehicleDetailsFromJSON,
    UserRewardLedgerEntryVehicleDetailsFromJSONTyped,
    UserRewardLedgerEntryVehicleDetailsToJSON,
    UserRewardLedgerEntryVehicleDetailsToJSONTyped,
} from './UserRewardLedgerEntryVehicleDetails';
import type { UserRewardLedgerEntryHotelDetails } from './UserRewardLedgerEntryHotelDetails';
import {
    UserRewardLedgerEntryHotelDetailsFromJSON,
    UserRewardLedgerEntryHotelDetailsFromJSONTyped,
    UserRewardLedgerEntryHotelDetailsToJSON,
    UserRewardLedgerEntryHotelDetailsToJSONTyped,
} from './UserRewardLedgerEntryHotelDetails';

/**
 *
 * @export
 * @interface UserRewardLedgerEntry
 */
export interface UserRewardLedgerEntry {
    /**
     *
     * @type {number}
     * @memberof UserRewardLedgerEntry
     */
    id: number;
    /**
     * Offer that awarded this promotional credit; absent for legacy and app promotions.
     * @type {string}
     * @memberof UserRewardLedgerEntry
     */
    welcomeBackOfferId?: string | null;
    /**
     *
     * @type {string}
     * @memberof UserRewardLedgerEntry
     */
    transactionType: UserRewardLedgerEntryTransactionTypeEnum;
    /**
     *
     * @type {number}
     * @memberof UserRewardLedgerEntry
     */
    amount: number;
    /**
     *
     * @type {string}
     * @memberof UserRewardLedgerEntry
     */
    currency: string;
    /**
     *
     * @type {boolean}
     * @memberof UserRewardLedgerEntry
     */
    pending: boolean;
    /**
     *
     * @type {number}
     * @memberof UserRewardLedgerEntry
     */
    bookingId?: number | null;
    /**
     * User-facing Gondola booking confirmation number.
     * @type {string}
     * @memberof UserRewardLedgerEntry
     */
    gondolaBookingId?: string | null;
    /**
     * Which product this row's booking_id refers to (hotel vs vehicle). NULL/absent = hotel. Lets the client render a vehicle row as a rental car instead of defaulting to a hotel.
     * @type {string}
     * @memberof UserRewardLedgerEntry
     */
    bookingType?: string | null;
    /**
     *
     * @type {string}
     * @memberof UserRewardLedgerEntry
     */
    referredUserId?: string | null;
    /**
     *
     * @type {number}
     * @memberof UserRewardLedgerEntry
     */
    referredBookingId?: number | null;
    /**
     *
     * @type {number}
     * @memberof UserRewardLedgerEntry
     */
    scheduledEventId?: number | null;
    /**
     *
     * @type {Date}
     * @memberof UserRewardLedgerEntry
     */
    createdAt: Date;
    /**
     *
     * @type {Date}
     * @memberof UserRewardLedgerEntry
     */
    updatedAt: Date;
    /**
     *
     * @type {Date}
     * @memberof UserRewardLedgerEntry
     */
    transactionDate: Date | null;
    /**
     *
     * @type {UserRewardLedgerEntryHotelDetails}
     * @memberof UserRewardLedgerEntry
     */
    hotelDetails?: UserRewardLedgerEntryHotelDetails | null;
    /**
     *
     * @type {UserRewardLedgerEntryVehicleDetails}
     * @memberof UserRewardLedgerEntry
     */
    vehicleDetails?: UserRewardLedgerEntryVehicleDetails | null;
    /**
     *
     * @type {UserRewardLedgerEntryReferredUserDetails}
     * @memberof UserRewardLedgerEntry
     */
    referredUserDetails?: UserRewardLedgerEntryReferredUserDetails | null;
}


/**
 * @export
 */
export const UserRewardLedgerEntryTransactionTypeEnum = {
    ReferralCredit: 'referral_credit',
    BookingCredit: 'booking_credit',
    SupportCredit: 'support_credit',
    BookingDebit: 'booking_debit',
    PromotionalCredit: 'promotional_credit',
    AmbassadorCredit: 'ambassador_credit',
    TopUpCredit: 'top_up_credit'
} as const;
export type UserRewardLedgerEntryTransactionTypeEnum = typeof UserRewardLedgerEntryTransactionTypeEnum[keyof typeof UserRewardLedgerEntryTransactionTypeEnum];


/**
 * Check if a given object implements the UserRewardLedgerEntry interface.
 */
export function instanceOfUserRewardLedgerEntry(value: object): value is UserRewardLedgerEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('transactionType' in value) || value['transactionType'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('pending' in value) || value['pending'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    return true;
}

export function UserRewardLedgerEntryFromJSON(json: any): UserRewardLedgerEntry {
    return UserRewardLedgerEntryFromJSONTyped(json, false);
}

export function UserRewardLedgerEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRewardLedgerEntry {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'welcomeBackOfferId': json['welcome_back_offer_id'] == null ? undefined : json['welcome_back_offer_id'],
        'transactionType': json['transaction_type'],
        'amount': json['amount'],
        'currency': json['currency'],
        'pending': json['pending'],
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'gondolaBookingId': json['gondola_booking_id'] == null ? undefined : json['gondola_booking_id'],
        'bookingType': json['booking_type'] == null ? undefined : json['booking_type'],
        'referredUserId': json['referred_user_id'] == null ? undefined : json['referred_user_id'],
        'referredBookingId': json['referred_booking_id'] == null ? undefined : json['referred_booking_id'],
        'scheduledEventId': json['scheduled_event_id'] == null ? undefined : json['scheduled_event_id'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'transactionDate': (json['transaction_date'] == null ? null : new Date(json['transaction_date'])),
        'hotelDetails': json['hotel_details'] == null ? undefined : UserRewardLedgerEntryHotelDetailsFromJSON(json['hotel_details']),
        'vehicleDetails': json['vehicle_details'] == null ? undefined : UserRewardLedgerEntryVehicleDetailsFromJSON(json['vehicle_details']),
        'referredUserDetails': json['referred_user_details'] == null ? undefined : UserRewardLedgerEntryReferredUserDetailsFromJSON(json['referred_user_details']),
    };
}

export function UserRewardLedgerEntryToJSON(json: any): UserRewardLedgerEntry {
    return UserRewardLedgerEntryToJSONTyped(json, false);
}

export function UserRewardLedgerEntryToJSONTyped(value?: UserRewardLedgerEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'id': value['id'],
        'welcome_back_offer_id': value['welcomeBackOfferId'],
        'transaction_type': value['transactionType'],
        'amount': value['amount'],
        'currency': value['currency'],
        'pending': value['pending'],
        'booking_id': value['bookingId'],
        'gondola_booking_id': value['gondolaBookingId'],
        'booking_type': value['bookingType'],
        'referred_user_id': value['referredUserId'],
        'referred_booking_id': value['referredBookingId'],
        'scheduled_event_id': value['scheduledEventId'],
        'created_at': value['createdAt'].toISOString(),
        'updated_at': value['updatedAt'].toISOString(),
        'transaction_date': value['transactionDate'] == null ? value['transactionDate'] : value['transactionDate'].toISOString(),
        'hotel_details': UserRewardLedgerEntryHotelDetailsToJSON(value['hotelDetails']),
        'vehicle_details': UserRewardLedgerEntryVehicleDetailsToJSON(value['vehicleDetails']),
        'referred_user_details': UserRewardLedgerEntryReferredUserDetailsToJSON(value['referredUserDetails']),
    };
}

